import { formatNumbers, LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'

import { Bar } from 'views/ReduceEmissions/Bar'

type EmissionsByCountryLane = {
    totalTeu: number
    totalEmissions: number
    carbonIntensity: number
    sourceCountry: string
    destinationCountry: string
    tradeLaneAverage: {
        name: string
        average: number
    } | null
}

const { palette } = LuneThemeNew

export const CountryLaneAndCarrierChart = ({
    data,
    highestTotalEmissions,
    highestCarbonIntensity,
    maxAverage,
}: {
    highestTotalEmissions: number
    highestCarbonIntensity: number
    maxAverage: number
    data: {
        totalLegs: number
        emissionsByCountryLane: Array<EmissionsByCountryLane>
    }
}) => {
    const { emissionsByCountryLane } = data

    return (
        <Box
            sx={{
                boxSizing: 'borderBox',
                '*': {
                    boxSizing: 'borderBox',
                },
            }}
        >
            {emissionsByCountryLane.map((e, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        gap: 3,
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        '> div': {
                            pt: 1,
                            pb: 1,
                            display: 'flex',
                            alignItems: 'center',
                            '&:nth-child(1)': {
                                width: '10%',
                            },
                            '&:nth-child(2)': {
                                width: '16%',
                            },
                            '&:nth-child(3)': {
                                width: '37%',
                            },
                            '&:nth-child(4)': {
                                width: '37%',
                            },
                        },
                    }}
                >
                    <Box>
                        <Text
                            variant={'body3'}
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {formatNumbers(Math.round(e.totalTeu))}
                        </Text>
                    </Box>
                    <Box>
                        <Text
                            variant={'body3'}
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {e.sourceCountry} - {e.destinationCountry}
                        </Text>
                    </Box>
                    <Box>
                        <Bar
                            value={e.totalEmissions}
                            maxValue={highestTotalEmissions}
                            color={palette.Data100}
                        />
                    </Box>
                    <Box>
                        <Bar
                            value={e.carbonIntensity}
                            maxValue={
                                highestCarbonIntensity > maxAverage
                                    ? highestCarbonIntensity
                                    : maxAverage
                            }
                            color={palette.Data1200}
                            average={e.tradeLaneAverage?.average}
                            averageUnit={'gCO₂e/TEU-km'}
                        />
                    </Box>
                </Box>
            ))}
        </Box>
    )
}
